<template>
  <div class="table-responsive">
    <table class="table table-sm text-center">
      <thead class="t-head thead-light text-center">
        <tr>
          <td></td>
          <td v-translate>No.</td>
          <td v-translate>Date</td>
          <td v-translate>Status</td>
          <td v-translate>User</td>
          <td v-translate>Pax</td>
          <td v-translate>Client</td>
          <td v-translate>Total payment</td>
          <td v-translate>Paid</td>
          <td v-translate>Rest payment</td>
          <td v-translate>Final payment</td>
        </tr>
      </thead>
      <tbody>
        <template v-for="(result, resIndex) in results">
          <BookingResult
            :booking="result"
            :key="'result' + resIndex"
            @view="$emit('view', result.id)"
            @editPassenger="$emit('editPassenger', $event)"/>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import BookingResult from './booking_result'

export default {
  name: 'BookingSearchResults',
  props: ['results'],
  components: { BookingResult }
}
</script>
